// | Logic for editing collections.
import * as $runtime from "../runtime.js";
import * as Control$dBind from "../Control.Bind/index.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dArray$dNonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data$dBifunctor from "../Data.Bifunctor/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dLeibniz from "../Data.Leibniz/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Partial from "../Partial/index.js";
import * as Record$dExtra from "../Record.Extra/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dDynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dInternal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dForm$dValue from "../Restaumatic.Form.Value/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dExtra from "../Specular.FRP.Extra/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dList from "../Specular.FRP.List/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dKeyedList from "../Specular.KeyedList/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Type$dEquality from "../Type.Equality/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
const $$for = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult);
  return x => f => traverse2(f)(x);
})();
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const traverse = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect))();
const for1 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Restaumatic$dForm$dFinal.applicativeFinal);
  return x => f => traverse2(f)(x);
})();
const queryWith = /* #__PURE__ */ (() => Restaumatic$dForm$dInternal.queryDynamic(Type$dEquality.refl).queryWith)();
const identity = x => x;
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dMap$dOrdered.foldableOMap);
const for2 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Effect.applicativeEffect);
  return x => f => traverse2(f)(x);
})();
const itemsIsSymbol = {reflectSymbol: () => "items"};
const subformIsSymbol = {reflectSymbol: () => "subform"};
const keyIsSymbol = {reflectSymbol: () => "key"};
const sequenceRecord1 = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle(itemsIsSymbol)()(Specular$dFRP$dBase.functorDynamic)()());
const for3 = /* #__PURE__ */ (() => {
  const traverse2 = Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic);
  return x => f => traverse2(f)(x);
})();
const sequenceRecord2 = /* #__PURE__ */ Record$dExtra.sequenceRecord()(/* #__PURE__ */ Record$dExtra.sequenceRecordCons(keyIsSymbol)()(Specular$dFRP$dBase.applyDynamic)(/* #__PURE__ */ Record$dExtra.sequenceRecordSingle(subformIsSymbol)()(Specular$dFRP$dBase.functorDynamic)()())()());
const for_ = /* #__PURE__ */ Data$dFoldable.for_(Effect.applicativeEffect);
const for_1 = /* #__PURE__ */ for_(Data$dFoldable.foldableMaybe);
const $$new = /* #__PURE__ */ Specular$dRef.new(Specular$dInternal$dRIO.monadEffectRIO);
const defineForm = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO);
const new1 = /* #__PURE__ */ Specular$dRef.new(Effect$dClass.monadEffectEffect);
const for_2 = /* #__PURE__ */ for_(Data$dMap$dOrdered.foldableOMap);
const LocalId = x => x;
const ListItem = x => x;
const List = x => x;
const showLocalId = Data$dShow.showInt;
const queryNonEmptyArrayList$pPa = dictQuery => (
  {
    queryImpl: v => Specular$dFRP$dBase.functorDynamic.map(v1 => Restaumatic$dForm$dResult.andThen(v1)(a => {
      if (a.length > 0) { return Restaumatic$dForm$dResult.$Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", a)); }
      return Restaumatic$dForm$dResult.$Result(
        Restaumatic$dForm$dInternal.tagErrors(v.name)(Restaumatic$dForm$dFinal.userVisibleErrors([
          Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
        ])),
        Restaumatic$dForm$dValue.$Value("NoValue", Data$dLeibniz.refl)
      );
    }))(dictQuery.queryImpl(v))
  }
);
const queryListItem = dictQuery => ({queryImpl: v => dictQuery.queryImpl(v.subform)});
const queryList$p = () => dictQuery => (
  {queryImpl: l => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Unsafe$dCoerce.unsafeCoerce))(dictQuery.queryImpl(l))}
);
const queryArrayT2List$p = dictQuery => (
  {
    queryImpl: v => Specular$dFRP$dBase.bindDynamic.bind(v.items._1)(items => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Data$dArray.catMaybes))($$for(Data$dFunctor.arrayMap(Data$dTuple.snd)(items._2))(v1 => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v2 => v3 => {
      if (v2) {
        return Restaumatic$dForm$dResult.functorResult.map((() => {
          const $0 = Data$dTuple$dT2.T2(v1.key);
          return x => Data$dMaybe.$Maybe("Just", $0(x));
        })())(v3);
      }
      return Restaumatic$dForm$dResult.$Result(Restaumatic$dForm$dFinal.monoidFormErrors.mempty, Restaumatic$dForm$dValue.$Value("SomeValue", Data$dMaybe.Nothing));
    })(Specular$dFRP$dBase.bindDynamic.bind(v1.presentWhen._1)(Control$dBind.identity)))(dictQuery.queryImpl(v1.subform)))))
  }
);
const queryOMapList$p = dictQuery => {
  const queryImpl = queryArrayT2List$p(dictQuery).queryImpl;
  return dictOrd => {
    const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
    return {
      queryImpl: l => {
        const $0 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
        return Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(x => {
          const $1 = $0(x);
          return Data$dMap$dOrdered.$OMap(fromFoldable($1), $1);
        }))(queryImpl(l));
      }
    };
  };
};
const queryMapList$p = dictQuery => {
  const queryOMapList$p1 = queryOMapList$p(dictQuery);
  return dictOrd => {
    const queryImpl = queryOMapList$p1(dictOrd).queryImpl;
    return {queryImpl: l => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Data$dMap$dOrdered.toMap))(queryImpl(l))};
  };
};
const queryArrayList$p = dictQuery => {
  const queryImpl = queryArrayT2List$p(dictQuery).queryImpl;
  return {queryImpl: l => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.functorResult.map(Data$dFunctor.arrayMap(Data$dTuple$dT2.proj2)))(queryImpl(l))};
};
const ordLocalId = Data$dOrd.ordInt;
const newtypeLocalId_ = {Coercible0: () => {}};
const mergeOrderedMultiSetList$p = dictMerge => ({merge: xs => l => dictMerge.merge(Data$dFunctor.arrayMap(Data$dTuple$dT2.fromTuple)(xs))(l)});
const mergeOMapList$p = dictMerge => ({merge: xs => l => dictMerge.merge(Data$dFunctor.arrayMap(Data$dTuple$dT2.fromTuple)(xs._2))(l)});
const mergeMapList$p = dictMerge => ({merge: xs => l => dictMerge.merge(Data$dFunctor.arrayMap(Data$dTuple$dT2.fromTuple)(toUnfoldable(xs)))(l)});
const mergeArrayList$p = dictMerge => (
  {
    merge: xs => v => {
      const $0 = traverse(x => {
        const $0 = v.generateId;
        return () => {
          const a$p = $0();
          return Data$dTuple$dT2.$T2(a$p, x);
        };
      })(xs);
      return () => {
        const withKey = $0();
        return dictMerge.merge(withKey)(v)();
      };
    }
  }
);
const isTextFieldListItem = dictIsTextField => ({textInput: v => dictIsTextField.textInput(v.subform)});
const initializeSomeInitialValu = dictInitialize => dictMerge => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => {
      const $0 = v.field;
      return Specular$dInternal$dRIO.pureImpl({
        field: $0,
        init: v1 => {
          const $1 = v1._1;
          return initializer => Specular$dInternal$dRIO.bindImpl(v.init(Restaumatic$dForm$dInternal.NoInitialValue)(initializer))(() => dictMerge.merge($1)($0));
        }
      });
    })
  }
);
const hasFieldIdListItem = dictShow => ({getFieldId: v => Restaumatic$dForm$dInternal.fieldPathToString(v.name)});
const hasFieldIdList$p = {getFieldId: v => Restaumatic$dForm$dInternal.fieldPathToString(v.name)};
const eqLocalId = Data$dEq.eqInt;
const eqListItem = {eq: Unsafe$dReference.reallyUnsafeRefEq};
const eqMaybe = {
  eq: x => y => {
    if (x.tag === "Nothing") { return y.tag === "Nothing"; }
    if (x.tag === "Just") {
      if (y.tag === "Just") { return Unsafe$dReference.reallyUnsafeRefEq(x._1)(y._1); }
      return false;
    }
    return false;
  }
};
const encodeLocalId = Foreign$dGeneric$dClass.intEncode;
const subform = v => v.subform;
const hasErrorsListItem = dictHasErrors => ({displayedErrors: f => dictHasErrors.displayedErrors(f.subform)});
const queryOMapArrayList = dictQuery => (
  {
    queryWith: strictness => v => Restaumatic$dForm$dFinal.bindFinal(Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v.items._1)))(items => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dArray.catMaybes))(for1(Data$dFunctor.arrayMap(Data$dTuple.snd)(items._2))(v1 => Restaumatic$dForm$dFinal.bindFinal(Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v1.presentWhen._1)))(presentF => Restaumatic$dForm$dFinal.bindFinal(queryWith(strictness)(presentF))(present => {
      if (present) {
        const $0 = Data$dTuple$dT2.T2(v1.key);
        return Specular$dFRP$dBase.functorDynamic.map(m => {
          if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
          if (m.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", $0(m._1))); }
          $runtime.fail();
        })(dictQuery.queryWith(strictness)(v1.subform));
      }
      return Restaumatic$dForm$dFinal.applicativeFinal.pure(Data$dMaybe.Nothing);
    })))))
  }
);
const queryOMapList = dictQuery => {
  const queryWith1 = queryOMapArrayList(dictQuery).queryWith;
  return dictOrd => {
    const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
    return {
      queryWith: strictness => l => {
        const $0 = Data$dFunctor.arrayMap(Data$dTuple$dT2.toTuple);
        return Specular$dFRP$dBase.functorDynamic.map(m => {
          if (m.tag === "Left") { return Data$dEither.$Either("Left", m._1); }
          if (m.tag === "Right") {
            return Data$dEither.$Either(
              "Right",
              (() => {
                const $1 = $0(m._1);
                return Data$dMap$dOrdered.$OMap(fromFoldable($1), $1);
              })()
            );
          }
          $runtime.fail();
        })(queryWith1(strictness)(l));
      }
    };
  };
};
const queryMapList$p1 = dictQuery => {
  const queryOMapList1 = queryOMapList(dictQuery);
  return dictOrd => {
    const queryWith1 = queryOMapList1(dictOrd).queryWith;
    return {queryWith: strictness => l => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dMap$dOrdered.toMap))(queryWith1(strictness)(l))};
  };
};
const queryNonEmptyArrayList = dictQuery => (
  {
    queryWith: strictness => v => Specular$dFRP$dBase.functorDynamic.map(Data$dBifunctor.bifunctorEither.bimap(Restaumatic$dForm$dInternal.tagErrors(v.name))(identity))(Restaumatic$dForm$dInternal.mapMaybeFinalUserVisible(Restaumatic$dI18n._translate(
      Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required),
      {}
    ))(Data$dArray$dNonEmpty.fromArray)(dictQuery.queryWith(strictness)(v)))
  }
);
const queryNewtypeList = () => dictQuery => (
  {queryWith: strictness => l => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Unsafe$dCoerce.unsafeCoerce))(dictQuery.queryWith(strictness)(l))}
);
const queryItem = dictQuery => ({queryWith: s => v => dictQuery.queryWith(s)(v.subform)});
const queryArrayList = dictQuery => {
  const queryWith1 = queryOMapArrayList(dictQuery).queryWith;
  return {
    queryWith: strictness => l => Specular$dFRP$dBase.functorDynamic.map(Data$dEither.functorEither.map(Data$dFunctor.arrayMap(Data$dTuple$dT2.proj2)))(queryWith1(strictness)(l))
  };
};
const presentWhen = v => v1 => v1.presentWhen._2(_old => v);
const numItems = v => Specular$dFRP$dBase.functorDynamic.map(Data$dMap$dOrdered.size)(v.items._1);
const newtypeListItem = {Coercible0: () => {}};
const newtypeList = {Coercible0: () => {}};
const newItem = dictShow => v => key1 => iv => {
  const $0 = Specular$dFRP$dHost.runHost(Specular$dInternal$dRIO.bindImpl((() => {
    const $0 = v.init;
    return () => $0.value;
  })())(init => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dBase.readDynamic(Specular$dInternal$dRIO.monadEffectRIO)(v.context._1))(ctx => Specular$dInternal$dRIO.bindImpl(init(v)({
    name: Data$dSemigroup.concatArray(v.name)([dictShow.show(key1)])
  })(key1)(iv))(item => Specular$dInternal$dRIO.bindImpl(v.addContext(ctx)(item.subform))(() => Specular$dInternal$dRIO.pureImpl(item))))));
  return () => {
    const v1 = $0();
    return {...v1._1, cleanup: v1._2};
  };
};
const mergeArrayT2List$pSomeInit = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return dictShow => (
    {
      merge: xs => v => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1);
        return () => {
          const oldItems = $0();
          traverse_(v1 => v1.cleanup)(oldItems)();
          const newItems = for2(xs)(v1 => {
            const $1 = Data$dTuple.Tuple(v1._1);
            const $2 = newItem(dictShow)(v)(v1._1)(Restaumatic$dForm$dInternal.$SomeInitialValue(v1._2));
            return () => {
              const a$p = $2();
              return $1(a$p);
            };
          })();
          const $1 = Data$dMap$dOrdered.$OMap(fromFoldable(newItems), newItems);
          return v.items._2(_old => $1)();
        };
      }
    }
  );
};
const moveItem = v => oldIndex => newIndex => v.items._2(items => {
  const $0 = Data$dMap$dOrdered.move(oldIndex)(newIndex)(items);
  if ($0.tag === "Nothing") { return items; }
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
});
const mergeNonEmptyArrayList = dictMerge => ({merge: x => dictMerge.merge(x)});
const mergeNewtypeList = () => dictMerge => ({merge: xs => l => dictMerge.merge(xs)(l)});
const mergeItem = dictMerge => ({merge: x => v => dictMerge.merge(x)(v.subform)});
const mergeArrayT2List$pNoInitia = dictShow => dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return dictMerge => (
    {
      merge: xs => v => {
        const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1);
        return () => {
          const oldItems = $0();
          traverse_(v1 => v1.cleanup)(oldItems)();
          const newItems = for2(xs)(v1 => {
            const $1 = v1._1;
            const $2 = v1._2;
            const $3 = newItem(dictShow)(v)($1)(Restaumatic$dForm$dInternal.NoInitialValue);
            return () => {
              const item = $3();
              dictMerge.merge($2)(item.subform)();
              return Data$dTuple.$Tuple($1, item);
            };
          })();
          const $1 = Data$dMap$dOrdered.$OMap(fromFoldable(newItems), newItems);
          return v.items._2(_old => $1)();
        };
      }
    }
  );
};
const key = v => v.key;
const itemForKey = dictOrd => {
  const lookup = Data$dMap$dOrdered.lookup(dictOrd)(dictOrd.Eq0());
  return v => k => Specular$dFRP$dBase.functorDynamic.map(lookup(k))(v.items._1);
};
const hasFieldItem = dictHasField => ({getField: label => v => dictHasField.getField(label)(v.subform)});
const generateLocalId = {
  newIdGenerator: () => {
    let next = 0;
    return () => {
      const $0 = next;
      return next = $0 + 1 | 0;
    };
  }
};
const dumpStateList = dictEncodeWithOptions => {
  const encode = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(itemsIsSymbol)((() => {
    const encode1 = Data$dFunctor.arrayMap(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(subformIsSymbol)({
      encodeWithOptions: v => Foreign$dGeneric$dClass.identity
    }))(keyIsSymbol)(dictEncodeWithOptions).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions));
    return {encodeWithOptions: v => encode1};
  })()).encodeRecordWithOptions(Type$dProxy.Proxy)(Foreign$dGeneric$dClass.defaultOptions);
  return dictDumpState => (
    {
      dumpState: v => Specular$dFRP$dBase.bindDynamic.bind(v.items._1)(items => Specular$dFRP$dBase.functorDynamic.map(encode)(sequenceRecord1({
        items: for3(Data$dFunctor.arrayMap(Data$dTuple.snd)(items._2))(v1 => sequenceRecord2({
          key: (() => {
            const $0 = v1.key;
            return (() => {
              const n = Specular$dInternal$dIncremental.constant($0);
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })();
          })(),
          subform: dictDumpState.dumpState(v1.subform)
        }))
      })))
    }
  );
};
const displayedItems = v => Specular$dFRP$dBase.functorDynamic.map(Data$dMap$dOrdered.values)(v.items._1);
const displayList$p = dictShow => l => renderItem => Specular$dKeyedList.keyedList(dictShow)("div")([])(Specular$dFRP$dBase.functorDynamic.map(Data$dMap$dOrdered.values)(l.items._1))(key)(ix => item => (
  {tag: "div", props: [], body: renderItem(ix)(item)}
));
const displayList = dictMonadFRP => {
  const dynamicListWithIndex_ = Specular$dFRP$dList.dynamicListWithIndex_(dictMonadFRP);
  return dictMonadReplace => {
    const dynamicListWithIndex_1 = dynamicListWithIndex_(dictMonadReplace);
    const withDynamic_ = Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace)(dictMonadFRP);
    return l => renderItem => dynamicListWithIndex_1(Specular$dFRP$dBase.functorDynamic.map(Data$dMap$dOrdered.values)(l.items._1))(ix => ditem => withDynamic_(ditem)(renderItem((() => {
      const n = Specular$dInternal$dIncremental.constant(ix);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })())));
  };
};
const displayKey = dictOrd => {
  const itemForKey1 = itemForKey(dictOrd);
  return dictMonadFRP => {
    const withUniqDynamic_ = Specular$dFRP$dExtra.withUniqDynamic_(dictMonadFRP);
    const traverse_1 = Data$dFoldable.traverse_(dictMonadFRP.MonadCleanup1().Monad0().Applicative0())(Data$dFoldable.foldableMaybe);
    return dictMonadReplace => {
      const withUniqDynamic_1 = withUniqDynamic_(dictMonadReplace)(eqMaybe);
      return field => k => display => withUniqDynamic_1(itemForKey1(field)(k))(traverse_1(display));
    };
  };
};
const deleteItemByKey = dictOrd => {
  const lookup = Data$dMap$dOrdered.lookup(dictOrd)(dictOrd.Eq0());
  const $$delete = Data$dMap$dOrdered.delete(dictOrd);
  return v => key_ => {
    const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1);
    return () => {
      const items_ = $0();
      return for_1(lookup(key_)(items_))(v1 => {
        const $1 = $$delete(key_)(items_);
        const $2 = v.items._2(_old => $1);
        return () => {
          $2();
          return v1.cleanup();
        };
      })();
    };
  };
};
const listItem$p = dictMakeEmpty => dictShow => dictOrd => {
  const deleteItemByKey1 = deleteItemByKey(dictOrd);
  return v => v1 => {
    const $0 = v1.init;
    return () => $0.value = parent1 => opts => key1 => iv => Specular$dInternal$dRIO.bindImpl($$new((() => {
      const n = Specular$dInternal$dIncremental.constant(true);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictMakeEmpty.makeEmptyImpl(opts))(subform1 => {
      const item = {
        name: Data$dSemigroup.concatArray(opts.name)([dictShow.show(key1)]),
        key: key1,
        subform: subform1,
        presentWhen: presentWhen_,
        cleanup: () => {},
        delete: deleteItemByKey1(parent1)(key1)
      };
      return Specular$dInternal$dRIO.bindImpl(defineForm(v(item)))(() => Specular$dInternal$dRIO.pureImpl(item));
    }));
  };
};
const listItem = dictMakeEmpty => dictShow => dictOrd => {
  const listItem$p3 = listItem$p(dictMakeEmpty)(dictShow)(dictOrd);
  return v => listItem$p3(x => v(x.subform));
};
const makeEmptyList = dictGenerateId => {
  const newIdGenerator = dictGenerateId.newIdGenerator;
  return dictMakeEmpty => dictAddContext => {
    const addContext = dictAddContext.addContext;
    return dictShow => dictOrd => {
      const deleteItemByKey1 = deleteItemByKey(dictOrd);
      return {
        makeEmptyImpl: opts => {
          const $0 = new1(Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []));
          return () => {
            const items = $0();
            const generateId = newIdGenerator();
            const context = new1(Data$dMap$dInternal.Leaf)();
            const init = {value: parent => opts1 => key1 => Partial._crashWith("List not fully initialized!")};
            const field = {name: opts.name, items, init, generateId, addContext, context};
            init.value = parent => opts1 => key1 => v => Specular$dInternal$dRIO.bindImpl($$new((() => {
              const n = Specular$dInternal$dIncremental.constant(true);
              Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
              return n;
            })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictMakeEmpty.makeEmptyImpl(opts1))(subform1 => Specular$dInternal$dRIO.pureImpl({
              name: Data$dSemigroup.concatArray(opts1.name)([dictShow.show(key1)]),
              key: key1,
              subform: subform1,
              presentWhen: presentWhen_,
              cleanup: () => {},
              delete: deleteItemByKey1(field)(key1)
            })));
            return field;
          };
        }
      };
    };
  };
};
const initializeNoInitialValueR = dictGenerateId => {
  const newIdGenerator = dictGenerateId.newIdGenerator;
  return dictAddContext => {
    const addContext = dictAddContext.addContext;
    return dictShow => dictOrd => {
      const deleteItemByKey1 = deleteItemByKey(dictOrd);
      return dictInitialize => dictTypeEquals => {
        const to = dictTypeEquals.proof(a => a);
        return {
          makeImpl: p => opts => {
            const $0 = new1(Data$dMap$dOrdered.$OMap(Data$dMap$dInternal.Leaf, []));
            return () => {
              const items = $0();
              const init = {value: parent => opts1 => key1 => Partial._crashWith("List not fully initialized!")};
              const generateId = newIdGenerator();
              const context = new1(Data$dMap$dInternal.Leaf)();
              const field = {name: opts.name, items, init, generateId, addContext, context};
              return {
                field,
                init: iv => initializer => () => init.value = parent => opts1 => key1 => iv1 => Specular$dInternal$dRIO.bindImpl($$new((() => {
                  const n = Specular$dInternal$dIncremental.constant(true);
                  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
                  return n;
                })()))(presentWhen_ => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts1))(v => {
                  const item = {
                    name: Data$dSemigroup.concatArray(opts1.name)([dictShow.show(key1)]),
                    key: key1,
                    subform: v.field,
                    presentWhen: presentWhen_,
                    cleanup: () => {},
                    delete: deleteItemByKey1(field)(key1)
                  };
                  return Specular$dInternal$dRIO.bindImpl(defineForm(v.init(iv1)(to(initializer).item(item))))(() => Specular$dInternal$dRIO.pureImpl(item));
                }))
              };
            };
          }
        };
      };
    };
  };
};
const deleteItem = v => v.delete;
const deleteItemCb = dictOrd => () => item => item.delete;
const addItem$p = dictOrd => {
  const insert = Data$dMap$dOrdered.insert(dictOrd);
  return dictShow => v => k => iv => {
    const $0 = newItem(dictShow)(v)(k)(Restaumatic$dForm$dInternal.$SomeInitialValue(iv));
    return () => {
      const item = $0();
      v.items._2(insert(k)(item))();
      return item;
    };
  };
};
const pushItem$p = dictOrd => {
  const addItem$p1 = addItem$p(dictOrd);
  return dictShow => {
    const addItem$p2 = addItem$p1(dictShow);
    return v => iv => {
      const $0 = v.generateId;
      return () => {
        const k = $0();
        return addItem$p2(v)(k)(iv)();
      };
    };
  };
};
const addItem = dictOrd => {
  const insert = Data$dMap$dOrdered.insert(dictOrd);
  return dictShow => v => k => {
    const $0 = newItem(dictShow)(v)(k)(Restaumatic$dForm$dInternal.NoInitialValue);
    return () => {
      const item = $0();
      v.items._2(insert(k)(item))();
      return item;
    };
  };
};
const pushItem = dictOrd => {
  const addItem1 = addItem(dictOrd);
  return dictShow => {
    const addItem2 = addItem1(dictShow);
    return v => {
      const $0 = v.generateId;
      return () => {
        const k = $0();
        return addItem2(v)(k)();
      };
    };
  };
};
const pushItemCb = () => dictOrd => {
  const pushItem1 = pushItem(dictOrd);
  return dictShow => {
    const pushItem2 = pushItem1(dictShow);
    return l => {
      const $0 = pushItem2(l);
      return () => {$0();};
    };
  };
};
const addContextList = dictAddContext => (
  {
    addContext: ctx => v => {
      const $0 = v.context._2(v1 => Data$dMap$dInternal.unsafeUnionWith(Data$dOrd.ordInt.compare, Data$dFunction.const, ctx, v1));
      return () => {
        $0();
        const items = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v.items._1)();
        return for_2(items)(item => dictAddContext.addContext(ctx)(item.subform))();
      };
    }
  }
);
export {
  List,
  ListItem,
  LocalId,
  addContextList,
  addItem,
  addItem$p,
  defineForm,
  deleteItem,
  deleteItemByKey,
  deleteItemCb,
  displayKey,
  displayList,
  displayList$p,
  displayedItems,
  dumpStateList,
  encodeLocalId,
  eqListItem,
  eqLocalId,
  eqMaybe,
  $$for as for,
  for1,
  for2,
  for3,
  for_,
  for_1,
  for_2,
  generateLocalId,
  hasErrorsListItem,
  hasFieldIdList$p,
  hasFieldIdListItem,
  hasFieldItem,
  identity,
  initializeNoInitialValueR,
  initializeSomeInitialValu,
  isTextFieldListItem,
  itemForKey,
  itemsIsSymbol,
  key,
  keyIsSymbol,
  listItem,
  listItem$p,
  makeEmptyList,
  mergeArrayList$p,
  mergeArrayT2List$pNoInitia,
  mergeArrayT2List$pSomeInit,
  mergeItem,
  mergeMapList$p,
  mergeNewtypeList,
  mergeNonEmptyArrayList,
  mergeOMapList$p,
  mergeOrderedMultiSetList$p,
  moveItem,
  $$new as new,
  new1,
  newItem,
  newtypeList,
  newtypeListItem,
  newtypeLocalId_,
  numItems,
  ordLocalId,
  presentWhen,
  pushItem,
  pushItem$p,
  pushItemCb,
  queryArrayList,
  queryArrayList$p,
  queryArrayT2List$p,
  queryItem,
  queryList$p,
  queryListItem,
  queryMapList$p,
  queryMapList$p1,
  queryNewtypeList,
  queryNonEmptyArrayList,
  queryNonEmptyArrayList$pPa,
  queryOMapArrayList,
  queryOMapList,
  queryOMapList$p,
  queryWith,
  sequenceRecord1,
  sequenceRecord2,
  showLocalId,
  subform,
  subformIsSymbol,
  toUnfoldable,
  traverse,
  traverse_
};
